import { CommonGet, CommonPost } from '../../helpers/HttpClient';
import tokenDecoder from '../../utils/tokenDecoder';

export default {
  GetAllBudgetCodes,
  GetBudgetCodesByID,
  SaveBudgetCode,
  UpdateBudgetCode,
}
//Get All SKUTypes
async function GetAllBudgetCodes() {
  const response = await CommonGet('/api/BudgetCode/GetAllAccountCodes');
  return response.data;
}
//Get SKUTypes By ID
async function GetBudgetCodesByID(budgetCodeID) {
  const response = await CommonGet('/api/BudgetCode/GetBudgetCodesByID', "budgetCodeID=" + parseInt(budgetCodeID));
  return response.data;
}
//Save SKUTypes
async function SaveBudgetCode(skutype) {

  let saveModel = {
    budgetCodeID: 0,
    budgetCode: skutype.budgetCode,
    budgetCodeName: skutype.budgetCodeName,
    budgetCodeDescription: skutype.budgetCodeDescription,
    isActive: skutype.isActive,
    createdBy: tokenDecoder.getUserIDFromToken(),
    createdDate: new Date().toISOString()
  }
  const response = await CommonPost('/api/BudgetCode/SaveBudgetCode', null, saveModel);
  return response;
}

//Update SKUTypes
async function UpdateBudgetCode(skutype) {

  let updateModel = {
    budgetCodeID: parseInt(skutype.budgetCodeID),
    budgetCode: skutype.budgetCode,
    budgetCodeName: skutype.budgetCodeName,
    budgetCodeDescription: skutype.budgetCodeDescription,
    isActive: skutype.isActive,
    modifiedBy: tokenDecoder.getUserIDFromToken(),
    modifiedDate: new Date().toISOString(),

  }
  const response = await CommonPost('/api/BudgetCode/UpdateBudgetCode', null, updateModel);
  return response;
}